import { render, staticRenderFns } from "./PublicIdChangeOwner.vue?vue&type=template&id=d54d6870&scoped=true&"
import script from "./PublicIdChangeOwner.vue?vue&type=script&lang=js&"
export * from "./PublicIdChangeOwner.vue?vue&type=script&lang=js&"
import style0 from "./PublicIdChangeOwner.vue?vue&type=style&index=0&id=d54d6870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54d6870",
  null
  
)

export default component.exports